import throttle from 'lodash/throttle'
import debounce from 'lodash/debounce'
import LocomotiveScroll from 'locomotive-scroll'

export default {
  data() {
    return {
      scrollPosition: 0
    }
  },
  watch: {
    $route() {
      if (window.lmS) window.lmS.update()
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (!this.$store.state.isMobile) {
        window.lmS = new LocomotiveScroll({
          el: document.querySelector('#js-scroll'),
          lerp: this.$store.state.isTablet ? 0.06 : 0.04,
          multiplier: this.$store.state.isTablet ? 2 : 1,
          getSpeed: this.$store.state.isTablet,
          smoothMobile: true,
          smooth: true
        })
        window.lmS.on('scroll', throttle(this.onLmsScroll, 150))
        window.addEventListener(
          'resize',
          debounce(this.onLmsResize.bind(this), 100)
        )
      }
    })
  },
  destroyed() {
    if (window.lmS) {
      window.lmS.destroy()
      window.removeEventListener('resize', this.onLmsResize)
    }
  },
  computed: {},
  methods: {
    onLmsScroll(obj) {
      this.scrollPosition = obj['scroll']['y']
    },
    onLmsResize() {
      if (window.lmS) window.lmS.update()
    }
  }
}
